import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../environments/environment';

@Component({
  standalone: true,
  imports: [RouterModule],
  providers: [],
  selector: 'app-root',
  template: ` <router-outlet></router-outlet> `,
  styles: ``,
})
export class AppComponent {
  title = 'ui';

  private readonly translateService = inject(TranslateService);

  constructor() {
    this.translateService.addLangs(['en', 'fr']);
    this.translateService.setFallbackLang(environment.defaultLanguage);
    this.translateService.use(environment.defaultLanguage);
  }
}
